import { render, staticRenderFns } from "./RepackingDetailScan.vue?vue&type=template&id=608a62a3&scoped=true&"
import script from "./RepackingDetailScan.vue?vue&type=script&lang=js&"
export * from "./RepackingDetailScan.vue?vue&type=script&lang=js&"
import style0 from "./RepackingDetailScan.vue?vue&type=style&index=0&id=608a62a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608a62a3",
  null
  
)

export default component.exports